export const isWhiteLabel = location?.pathname?.startsWith("/public/wl/");
